import React from 'react'
import { observer } from "mobx-react-lite"

import clsx from 'clsx'
import Skeleton from '@mui/material/Skeleton';
import styles from './LoopRow.module.scss'



const SkeletonRow = observer(({index, showCover}) => {
  const rowClz = index % 2 === 0 ? styles['even'] : styles['odd']

  return <div className={clsx(styles['root'], rowClz)} style={{minHeight: 50}}>
    {showCover ? <div className={styles['cover']}>
      <Skeleton width={30} height={45} style={{margin: '0 auto'}} />
    </div> : null}
    <div className={showCover ? styles['bars-cover'] : styles['bars']}>
      <div className={styles['play']}>
        <Skeleton variant="circular" width={30} height={30} style={{margin: '0 auto'}} />
      </div>
    </div>
    <div className={styles['process']}>
      <Skeleton  width="80%" height={45} />
    </div>
    <div className={styles['name']}>
      <Skeleton width="80%" height={45} />
    </div>
    <div className={styles['modified']}>
      <Skeleton width="80%" height={45} />
    </div>
    <div className={styles['key']}>
      <Skeleton width="80%"  height={45} />
    </div>
    <div className={styles['bpm']}>
      <Skeleton width="80%"  height={45} />
    </div>
    <div className={styles['action']}>
      <Skeleton variant="circular" className={styles['add-action']}  width={30} height={30} />
      <Skeleton variant="circular" className={styles['viewer-action']}  width={30} height={30} />
      <Skeleton variant="circular" className={styles['download-action']}  width={30} height={30} />
      <Skeleton variant="circular"  width={30} height={30} style={{display: 'inline-block'}} />
    </div>
  </div>
})

export default SkeletonRow;